import { Col, FloatingLabel, FormCheck, FormControl, Row } from "react-bootstrap";
import Validator from "../../../../services/Validator";
import CommonUtils from "../../../../utils/common";
import EnergoTooltip from "../../../shared/EnergoTooltip";
import { useState } from "react";
import RegisterAnlageSmallCard from "../../../anlage/RegisterAnlageSmallCard";
import AnlageRegisterElvCard from "../../../anlage/AnlageRegisterElvCard";


const RegisterMask = ({ data, setData, formError, setFormError, hwMode }) => {

    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();
    const [hasDifferentIBAN, setHasDifferentIBAN] = useState(false);

    const registerHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                register: isChecked
            }));
        } else {
            setData(prev => ({
                ...prev,
                register: isChecked,
                registerDate: "",
                x_zaehlerstand_01: "",
                x_zaehlerstand_02: "",
                useMtu: false,
                mtuName: "",
                mtuDirect: false,
                mtuPaysOverTransfer: false,
                mtuAccountOwner: "",
                mtuIban: "",
                monthlyPayment: false,
            }));
        }
    }

    const mtuHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                useMtu: isChecked
            }));
        } else {
            setData(prev => ({
                ...prev,
                useMtu: isChecked,
                mtuName: "",
                mtuDirect: false,
                mtuPaysOverTransfer: false,
                mtuAccountOwner: "",
                mtuIban: ""
            }));
        }
    }

    const mtuPaysOverTransferHandler = (e) => {
        const isChecked = e.target.checked;
        setFormError({});

        if (isChecked) {
            setData(prev => ({
                ...prev,
                mtuPaysOverTransfer: isChecked,
            }));
        } else {
            setData(prev => ({
                ...prev,
                mtuPaysOverTransfer: isChecked
            }));
        }
    }

    const ibanHandler = (e) => {
        const inputValue = e.target.value;

        // replace any characters that aren't digit or letter
        const formatedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');

        // group character in 4 block
        const formated4group = formatedValue.substring(0).replace(/(.{4})(?!$)/g, "$1 ");

        // return new value with uppercase
        return formated4group.toUpperCase()
    }

    const zaehlerstandHandler = (e, zaehler) => {
        const value = e.target.value;

        if (zaehler === 1) {
            if (/^[0-9,]*$/.test(value)) {
                setData(prev => ({
                    ...prev,
                    x_zaehlerstand_01: value
                }));

                setFormError({});
            }
        }
        if (zaehler === 2) {
            if (/^[0-9,]*$/.test(value)) {
                setData(prev => ({
                    ...prev,
                    x_zaehlerstand_02: value
                }));

                setFormError({});
            }
        }
    }

    return (
        <>
            <p className="text-energo"><b>Anmeldedaten</b></p>
            {data.anlagen && data.anlagen.length > 0 &&
                data.anlagen.map(a => (
                    <div className="mb-3">
                        <AnlageRegisterElvCard
                            anlage={a}
                            data={data}
                            setData={setData}
                            errors={formError}
                            setErrors={setFormError}
                        />
                    </div>
                ))
            }
            <Row hidden={hwMode}>
                <Col xs="12" md="4" xl="3">
                    <FormCheck
                        type="radio"
                        name="situationRadios"
                        label="Wechsel"
                        value={"Wechsel"}
                        checked={data.situation === "Wechsel"}
                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                    />
                    <FormCheck
                        type="radio"
                        name="situationRadios"
                        label="Neuanmeldung"
                        value={"Neuanmeldung"}
                        checked={data.situation === "Neuanmeldung"}
                        onChange={e => setData(prev => ({ ...prev, situation: e.target.value }))}
                    />
                </Col>
                <Col xs="12" md="8" xl="9" hidden={data.situation === undefined}>
                    {
                        data.situation && data.situation === "Wechsel" ?
                            <small>
                                Es besteht bereits ein laufender Energieliefervertrag
                                auf meinen Namen. ENERGO sorgt für regelmäßige Wechsel
                                zu günstigen Energielieferanten.
                            </small> :
                            <small>
                                Es besteht KEIN laufender Energieliefervertrag auf
                                meinen Namen. ENERGO führt die Anmeldung durch und sorgt
                                für regelmäßige Wechsel zu günstigen Energielieferanten.
                            </small>
                    }
                </Col>
            </Row>
            <Row className="mt-3 align-items-center" hidden={!hwMode}>
                <Col xs="12" md="6" xl="4" className="d-flex">
                    <FormCheck
                        className="me-2"
                        label="Anlage bei Energielieferant anmelden"
                        checked={data.register}
                        onChange={e => registerHandler(e)}
                    />
                    <EnergoTooltip tKey="106" position="right" />
                </Col>
                <Col xs="12" md="6" xl="8">
                    {
                        data.register === true ?
                            <small>Anlage wird bei ENERGO hinzugefügt und bei Energielieferant angemeldet</small> :
                            data.register === false ?
                                <small>Anlage wird nur bei ENERGO hinzugefügt.</small> :
                                null
                    }
                </Col>
            </Row>
            <Row className="mt-3 align-items-center" hidden={data.anlagen && data.anlagen.length > 0}>
                <Col xs="12" md="5" xl="4">
                    <FloatingLabel label="Anlage anmelden am">
                        <FormControl
                            disabled={data.register === false}
                            type="date"
                            placeholder="Anlage anmelden am"
                            value={data.registerDate}
                            onChange={e => { setData(prev => ({ ...prev, registerDate: e.target.value })); setFormError({}) }}
                            isValid={VALIDATOR.dateValid(data.registerDate)}
                            isInvalid={formError.registerDate}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="7" xl="8">
                    <small hidden={!data.registerDate || UTILS.compareDate(new Date(data.registerDate), ">", new Date())}>
                        Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung
                        wird in Abstimmung mit dem Energielieferanten am frühest
                        möglichen Zeitpunkt durchgeführt.
                    </small>
                </Col>
            </Row>
            <Row className="mt-3" hidden={data.anlagen && data.anlagen.length > 0}>
                <Col xs="12" md="6" xl="6" hidden={data.smartmeter === true}>
                    <FloatingLabel label={`Zählerstand ${data.x_is_smartmeter_01 === true ? "(wenn vorhanden)" : ""}`}>
                        <FormControl
                            disabled={data.register === false}
                            placeholder="Zählerstand"
                            value={data.x_zaehlerstand_01}
                            onChange={e => zaehlerstandHandler(e, 1)}
                            isValid={data.x_zaehlerstand_01 && data.x_zaehlerstand_01 !== "" && VALIDATOR.IsZaehlerstand(data.x_zaehlerstand_01)}
                            isInvalid={formError.x_zaehlerstand_01}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="6" xl="6" hidden={data.smartmeter === true || !data.secondZaehler}>
                    <FloatingLabel label={`Zählerstand 2  ${data.x_is_smartmeter_01 === true ? "(wenn vorhanden)" : ""}`}>
                        <FormControl
                            disabled={data.register === false}
                            placeholder="Zweiter Zählerstand"
                            value={data.x_zaehlerstand_02}
                            onChange={e => zaehlerstandHandler(e, 2)}
                            isValid={data.x_zaehlerstand_02 && data.x_zaehlerstand_02 !== "" && VALIDATOR.IsZaehlerstand(data.x_zaehlerstand_02)}
                            isInvalid={formError.x_zaehlerstand_02}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            {hwMode ?
                <>
                    <Row className="mt-3" hidden={data.energyForm !== "Strom" || data.x_is_smartmeter_01 === false}>
                        <div className="d-flex gap-2 align-items-center">
                            <FormCheck
                                disabled={data.register === false}
                                label="Monatliche Abrechnung durch Energielieferant"
                                onChange={e => setData(prev => ({ ...prev, monthlyPayment: e.target.checked }))}
                            />
                            <EnergoTooltip tKey="109" position="right" />
                        </div>
                    </Row>
                    <Row className="mt-3 align-items-center">
                        <Col xs="12" md="12" xl="6" className="d-flex">
                            <FormCheck
                                disabled={data.register === false}
                                className="me-2"
                                label="Abrechnung über Messtechnikunternehmen"
                                checked={data.useMtu}
                                onChange={e => mtuHandler(e)}
                            />
                            <EnergoTooltip tKey="107" position="right" />
                        </Col>
                        <Col xs="12" md="12" xl="6" hidden={!data.useMtu}>
                            <FloatingLabel label="Name des Messtechnikunternehmens">
                                <FormControl
                                    placeholder="Name des Messtechnikunternehmens"
                                    value={data.mtuName}
                                    onChange={e => { setData(prev => ({ ...prev, mtuName: e.target.value })); setFormError({}) }}
                                    isValid={data.mtuName && data.mtuName.length > 3}
                                    isInvalid={formError.mtuName}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                    <Row className="mt-3" hidden={!data.useMtu}>
                        <Col xs="12" md="5" xl="6" className="d-flex">
                            <FormCheck
                                className="me-2"
                                label="Direktverrechnung"
                                checked={data.mtuDirect}
                                onChange={e => { setData(prev => ({ ...prev, mtuDirect: e.target.checked })); setFormError({}) }}
                            />
                            <EnergoTooltip tKey="108" position="right" />
                        </Col>
                        <Col xs="12" md="7" xl="6" hidden={!data.mtuDirect}>
                            <FormCheck
                                label="Messtechnikunternehmen zahlt per Überweisung"
                                checked={data.mtuPaysOverTransfer}
                                onChange={e => mtuPaysOverTransferHandler(e)}
                            />
                        </Col>
                    </Row>
                    <Row className="mt-3" hidden={!data.useMtu || !data.mtuDirect}>
                        <p hidden={data.mtuDirect === true && data.mtuPaysOverTransfer === false}>
                            <small>Die IBAN und Kontoinhaber muss zur Rücküberweisung von Guthaben angegeben werden.</small>
                        </p>
                        <Col xs="12" md="5" xl="6">
                            <FloatingLabel label="Kontoinhaber">
                                <FormControl
                                    placeholder="Kontoinhaber"
                                    value={data.mtuAccountOwner}
                                    onChange={e => { setData(prev => ({ ...prev, mtuAccountOwner: e.target.value })); setFormError({}) }}
                                    isValid={data.mtuAccountOwner && data.mtuAccountOwner.length > 3}
                                    isInvalid={formError.mtuAccountOwner}
                                />
                            </FloatingLabel>
                        </Col>
                        <Col xs="12" md="7" xl="6">
                            <FloatingLabel label="IBAN">
                                <FormControl
                                    placeholder="IBAN"
                                    value={data.mtuIban}
                                    onChange={e => { setData(prev => ({ ...prev, mtuIban: ibanHandler(e) })); setFormError({}) }}
                                    isValid={data.mtuIban && VALIDATOR.ibanValid(data.mtuIban.replace(/\s+/g, ''))}
                                    isInvalid={formError.mtuIban}
                                />
                            </FloatingLabel>
                        </Col>
                    </Row>
                </> :
                <>
                    <Row className="mt-3" hidden={data.energyForm !== "Strom" || data.x_is_smartmeter_01 === false}>
                        <div className="d-flex gap-2 align-items-center">
                            <FormCheck
                                label="Monatliche Abrechnung durch Energielieferant"
                                onChange={e => setData(prev => ({ ...prev, monthlyPayment: e.target.checked }))}
                            />
                            <EnergoTooltip tKey="109" position="right" />
                        </div>
                    </Row>
                    <Row className="mt-3" hidden={data.anlagen && data.anlagen.length > 0}>
                        <Col xs="12">
                            <FormCheck label="Abweichende Kontonummer verwenden" onChange={e => setData(prev => ({ ...prev, hasDifferentAccount: e.target.checked }))} defaultChecked={data.hasDifferentAccount} />
                        </Col>
                    </Row>
                    {data.hasDifferentAccount &&
                        <Row className="mt-3">
                            <Col xs="12" md="6" xl="6">
                                <FloatingLabel label="Kontoinhaber">
                                    <FormControl
                                        placeholder="Kontoinhaber"
                                        value={data.kontoinhaber}
                                        onChange={e => { setData(prev => ({ ...prev, kontoinhaber: e.target.value })); setFormError({}) }}
                                        isValid={data.kontoinhaber && data.kontoinhaber.length > 3}
                                        isInvalid={formError.kontoinhaber}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xs="12" md="6" xl="6">
                                <FloatingLabel label="IBAN">
                                    <FormControl
                                        placeholder="IBAN"
                                        value={data.iban}
                                        onChange={e => { setData(prev => ({ ...prev, iban: ibanHandler(e) })); setFormError({}) }}
                                        isValid={data.iban && VALIDATOR.ibanValid(data.iban.replace(/\s+/g, ''))}
                                        isInvalid={formError.iban}
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>
                    }
                </>
            }
        </>
    )
}
export default RegisterMask;